import { createFetchedDataRecord, updateFetchedDataRecord, wrapInArray } from '@vista-digital/utilities';
import { browsingDomainStore } from '../../../browsing/store';
import { seatingDomainStore } from '../../store';
export const assignSeatLayoutRelatedData = (relatedData, cacheDuration) => {
    const { areaCategories, screen } = relatedData;
    updateFetchedDataRecord(seatingDomainStore.data.areaCategories, createFetchedDataRecord(areaCategories, 'id', cacheDuration));
    updateFetchedDataRecord(browsingDomainStore.data.screensById, createFetchedDataRecord(wrapInArray(screen), 'id', cacheDuration));
};
//# sourceMappingURL=assign-seat-layout-related-data.js.map